// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://klehlrqugnbyiiagjkaf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtsZWhscnF1Z25ieWlpYWdqa2FmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI3ODQ2MDcsImV4cCI6MjA1ODM2MDYwN30.oB4mzT1yYkxF5N6Z1KaLEGviO-XppDcrconuhe0D5lU";

// Get the current URL for redirect
const getRedirectUrl = () => {
  // For client-side, use the current URL
  if (typeof window !== 'undefined' && window.location) {
    const currentUrl = window.location.origin;
    return currentUrl.includes('localhost') || currentUrl.includes('127.0.0.1')
      ? `${currentUrl}/auth/callback`
      : 'https://app.binauralflow.ai/auth/callback';
  }
  
  // For backend, use process.env
  return process.env.NODE_ENV === 'development'
    ? 'http://localhost:8080/auth/callback'  // Default to 8080 for development
    : 'https://app.binauralflow.ai/auth/callback';
};

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
});